module.exports = __webpack_public_path__ + "static/media/show5.398dd7e2.png";